/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_CollapseInputs */

const en_ui_collapse = /** @type {(inputs: Ui_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse`)
};

/** @type {(inputs: Ui_CollapseInputs) => LocalizedString} */
const ar_ui_collapse = en_ui_collapse;

/** @type {(inputs: Ui_CollapseInputs) => LocalizedString} */
const he_ui_collapse = en_ui_collapse;

/** @type {(inputs: Ui_CollapseInputs) => LocalizedString} */
const ur_ui_collapse = en_ui_collapse;

/** @type {(inputs: Ui_CollapseInputs) => LocalizedString} */
const es_ui_collapse = en_ui_collapse;

/** @type {(inputs: Ui_CollapseInputs) => LocalizedString} */
const fr_ui_collapse = en_ui_collapse;

/** @type {(inputs: Ui_CollapseInputs) => LocalizedString} */
const de_ui_collapse = en_ui_collapse;

/** @type {(inputs: Ui_CollapseInputs) => LocalizedString} */
const pt_ui_collapse = en_ui_collapse;

/** @type {(inputs: Ui_CollapseInputs) => LocalizedString} */
const hi_ui_collapse = en_ui_collapse;

/** @type {(inputs: Ui_CollapseInputs) => LocalizedString} */
const bn_ui_collapse = en_ui_collapse;

/**
* | output |
* | --- |
* | "Collapse" |
*
* @param {Ui_CollapseInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_collapse = /** @type {((inputs?: Ui_CollapseInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_CollapseInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_collapse(inputs)
	if (locale === "he") return he_ui_collapse(inputs)
	if (locale === "ur") return ur_ui_collapse(inputs)
	if (locale === "es") return es_ui_collapse(inputs)
	if (locale === "fr") return fr_ui_collapse(inputs)
	if (locale === "de") return de_ui_collapse(inputs)
	if (locale === "pt") return pt_ui_collapse(inputs)
	if (locale === "hi") return hi_ui_collapse(inputs)
	if (locale === "bn") return bn_ui_collapse(inputs)
	return /** @type {LocalizedString} */ ("Collapse")
});